import '../../assets/index54.css';var Ce = Object.defineProperty, Ie = Object.defineProperties;
var Se = Object.getOwnPropertyDescriptors;
var k = Object.getOwnPropertySymbols;
var Y = Object.prototype.hasOwnProperty, G = Object.prototype.propertyIsEnumerable;
var Q = (t, e, n) => e in t ? Ce(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, d = (t, e) => {
  for (var n in e || (e = {}))
    Y.call(e, n) && Q(t, n, e[n]);
  if (k)
    for (var n of k(e))
      G.call(e, n) && Q(t, n, e[n]);
  return t;
}, f = (t, e) => Ie(t, Se(e));
var z = (t, e) => {
  var n = {};
  for (var o in t)
    Y.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
  if (t != null && k)
    for (var o of k(t))
      e.indexOf(o) < 0 && G.call(t, o) && (n[o] = t[o]);
  return n;
};
import { jsx as y, jsxs as Z } from "react/jsx-runtime";
import { useEffect as R, useRef as g, useCallback as J, useState as N, createElement as P, forwardRef as Ne } from "react";
import { a as Re, c as Te, e as $e } from "../../get-size-Bc1Pz5yf.js";
import { c as ee } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as te, u as ne, B as E, b as xe, h as ze } from "../../factory-ueRxoNOV.js";
import { g as We } from "../../get-contrast-color-SC35uhiM.js";
import { u as oe } from "../../use-styles-DToiHEa6.js";
import { g as ke } from "../../get-env-CiXMSQeN.js";
import { t as O } from "../../to-int-CHbRl5M-.js";
import { u as re } from "../../use-merged-ref-n551Tfbr.js";
import { r as V, u as Oe } from "../../use-id-D2tGiO9x.js";
import { u as Ee } from "../../use-uncontrolled-BT_j5D2R.js";
import { V as Fe } from "../../VisuallyHidden-BdfWO2mJ.js";
function Le(t, e) {
  if (t === e || Number.isNaN(t) && Number.isNaN(e))
    return !0;
  if (!(t instanceof Object) || !(e instanceof Object))
    return !1;
  const n = Object.keys(t), { length: o } = n;
  if (o !== Object.keys(e).length)
    return !1;
  for (let r = 0; r < o; r += 1) {
    const i = n[r];
    if (!(i in e) || t[i] !== e[i] && !(Number.isNaN(t[i]) && Number.isNaN(e[i])))
      return !1;
  }
  return !0;
}
function je(t, e) {
  if (!t || !e)
    return !1;
  if (t === e)
    return !0;
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; n += 1)
    if (!Le(t[n], e[n]))
      return !1;
  return !0;
}
function Pe(t) {
  const e = g([]), n = g(0);
  return je(e.current, t) || (e.current = t, n.current += 1), [n.current];
}
function Be(t, e) {
  R(t, Pe(e));
}
function Me(t, e, n = { autoInvoke: !1 }) {
  const o = g(null), r = J(
    (...l) => {
      o.current || (o.current = window.setTimeout(() => {
        t(l), o.current = null;
      }, e));
    },
    [e]
  ), i = J(() => {
    o.current && (window.clearTimeout(o.current), o.current = null);
  }, []);
  return R(() => (n.autoInvoke && r(), i), [i, r]), { start: r, clear: i };
}
function De(t, e, n) {
  const o = g(null), r = g(null);
  return R(() => {
    const i = typeof n == "function" ? n() : n;
    return (i || r.current) && (o.current = new MutationObserver(t), o.current.observe(i || r.current, e)), () => {
      var l;
      (l = o.current) == null || l.disconnect();
    };
  }, [t, e]), r;
}
function Ae() {
  const [t, e] = N(!1);
  return R(() => e(!0), []), t;
}
function He(t, e) {
  if (!e || !t)
    return !1;
  let n = e.parentNode;
  for (; n != null; ) {
    if (n === t)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
function Ue({
  target: t,
  parent: e,
  ref: n,
  displayAfterTransitionEnd: o
}) {
  const r = g(-1), [i, l] = N(!1), [m, w] = N(
    typeof o == "boolean" ? o : !1
  ), c = () => {
    if (!t || !e || !n.current)
      return;
    const a = t.getBoundingClientRect(), u = e.getBoundingClientRect(), b = window.getComputedStyle(t), p = window.getComputedStyle(e), T = O(b.borderTopWidth) + O(p.borderTopWidth), I = O(b.borderLeftWidth) + O(p.borderLeftWidth), _ = {
      top: a.top - u.top - T,
      left: a.left - u.left - I,
      width: a.width,
      height: a.height
    };
    n.current.style.transform = `translateY(${_.top}px) translateX(${_.left}px)`, n.current.style.width = `${_.width}px`, n.current.style.height = `${_.height}px`;
  }, h = () => {
    window.clearTimeout(r.current), n.current && (n.current.style.transitionDuration = "0ms"), c(), r.current = window.setTimeout(() => {
      n.current && (n.current.style.transitionDuration = "");
    }, 30);
  }, C = g(null), v = g(null);
  return R(() => {
    if (c(), t)
      return C.current = new ResizeObserver(h), C.current.observe(t), e && (v.current = new ResizeObserver(h), v.current.observe(e)), () => {
        var a, u;
        (a = C.current) == null || a.disconnect(), (u = v.current) == null || u.disconnect();
      };
  }, [e, t]), R(() => {
    if (e) {
      const a = (u) => {
        He(u.target, e) && (h(), w(!1));
      };
      return e.addEventListener("transitionend", a), () => {
        e.removeEventListener("transitionend", a);
      };
    }
  }, [e]), Me(
    () => {
      ke() !== "test" && l(!0);
    },
    20,
    { autoInvoke: !0 }
  ), De(
    (a) => {
      a.forEach((u) => {
        u.type === "attributes" && u.attributeName === "dir" && h();
      });
    },
    { attributes: !0, attributeFilter: ["dir"] },
    () => document.documentElement
  ), { initialized: i, hidden: m };
}
var se = { root: "m_96b553a6" };
const Xe = {}, qe = ee(
  (t, { transitionDuration: e }) => ({
    root: {
      "--transition-duration": typeof e == "number" ? `${e}ms` : e
    }
  })
), B = te((t, e) => {
  const n = ne("FloatingIndicator", Xe, t), $ = n, {
    classNames: o,
    className: r,
    style: i,
    styles: l,
    unstyled: m,
    vars: w,
    target: c,
    parent: h,
    transitionDuration: C,
    mod: v,
    displayAfterTransitionEnd: a
  } = $, u = z($, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "target",
    "parent",
    "transitionDuration",
    "mod",
    "displayAfterTransitionEnd"
  ]), b = oe({
    name: "FloatingIndicator",
    classes: se,
    props: n,
    className: r,
    style: i,
    classNames: o,
    styles: l,
    unstyled: m,
    vars: w,
    varsResolver: qe
  }), p = g(null), { initialized: T, hidden: I } = Ue({
    target: c,
    parent: h,
    ref: p,
    displayAfterTransitionEnd: a
  }), _ = re(e, p);
  return !c || !h ? null : /* @__PURE__ */ y(E, d(d({ ref: _, mod: [{ initialized: T, hidden: I }, v] }, b("root")), u));
});
B.displayName = "@mantine/core/FloatingIndicator";
B.classes = se;
var ie = { root: "m_cf365364", indicator: "m_9e182ccd", label: "m_1738fcb2", input: "m_1714d588", control: "m_69686b9b", innerLabel: "m_78882f40" };
const Ke = {
  withItemsBorders: !0
}, Qe = ee(
  (t, { radius: e, color: n, transitionDuration: o, size: r, transitionTimingFunction: i }) => ({
    root: {
      "--sc-radius": e === void 0 ? void 0 : $e(e),
      "--sc-color": n ? ze(n, t) : void 0,
      "--sc-shadow": n ? void 0 : "var(--mantine-shadow-xs)",
      "--sc-transition-duration": o === void 0 ? void 0 : `${o}ms`,
      "--sc-transition-timing-function": i,
      "--sc-padding": Te(r, "sc-padding"),
      "--sc-font-size": Re(r)
    }
  })
), M = te((t, e) => {
  var U, X, q, K;
  const n = ne("SegmentedControl", Ke, t), H = n, {
    classNames: o,
    className: r,
    style: i,
    styles: l,
    unstyled: m,
    vars: w,
    data: c,
    value: h,
    defaultValue: C,
    onChange: v,
    size: a,
    name: u,
    disabled: b,
    readOnly: p,
    fullWidth: T,
    orientation: I,
    radius: _,
    color: $,
    transitionDuration: rt,
    transitionTimingFunction: st,
    variant: ae,
    autoContrast: le,
    withItemsBorders: ce,
    mod: ue
  } = H, de = z(H, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "data",
    "value",
    "defaultValue",
    "onChange",
    "size",
    "name",
    "disabled",
    "readOnly",
    "fullWidth",
    "orientation",
    "radius",
    "color",
    "transitionDuration",
    "transitionTimingFunction",
    "variant",
    "autoContrast",
    "withItemsBorders",
    "mod"
  ]), S = oe({
    name: "SegmentedControl",
    props: n,
    classes: ie,
    className: r,
    style: i,
    classNames: o,
    styles: l,
    unstyled: m,
    vars: w,
    varsResolver: Qe
  }), D = xe(), A = c.map(
    (s) => typeof s == "string" ? { label: s, value: s } : s
  ), fe = Ae(), [me, he] = N(V()), [be, ge] = N(null), [F, pe] = N({}), ve = (s, j) => {
    F[j] = s, pe(F);
  }, [x, _e] = Ee({
    value: h,
    defaultValue: C,
    finalValue: Array.isArray(c) && (K = (q = (U = A.find((s) => !s.disabled)) == null ? void 0 : U.value) != null ? q : (X = c[0]) == null ? void 0 : X.value) != null ? K : null,
    onChange: v
  }), L = Oe(u), ye = A.map((s) => /* @__PURE__ */ P(
    E,
    f(d({}, S("control")), {
      mod: { active: x === s.value, orientation: I },
      key: s.value
    }),
    /* @__PURE__ */ P(
      "input",
      f(d({}, S("input")), {
        disabled: b || s.disabled,
        type: "radio",
        name: L,
        value: s.value,
        id: `${L}-${s.value}`,
        checked: x === s.value,
        onChange: () => !p && _e(s.value),
        "data-focus-ring": D.focusRing,
        key: `${s.value}-input`
      })
    ),
    /* @__PURE__ */ P(
      E,
      f(d({
        component: "label"
      }, S("label")), {
        mod: {
          active: x === s.value && !(b || s.disabled),
          disabled: b || s.disabled,
          "read-only": p
        },
        htmlFor: `${L}-${s.value}`,
        ref: (j) => ve(j, s.value),
        __vars: {
          "--sc-label-color": $ !== void 0 ? We({ color: $, theme: D, autoContrast: le }) : void 0
        },
        key: `${s.value}-label`
      }),
      /* @__PURE__ */ y("span", f(d({}, S("innerLabel")), { children: s.label }))
    )
  )), we = re(e, (s) => ge(s));
  return Be(() => {
    he(V());
  }, [c.length]), c.length === 0 ? null : /* @__PURE__ */ Z(
    E,
    f(d(f(d({}, S("root")), {
      variant: ae,
      size: a,
      ref: we,
      mod: [
        {
          "full-width": T,
          orientation: I,
          initialized: fe,
          "with-items-borders": ce
        },
        ue
      ]
    }), de), {
      role: "radiogroup",
      "data-disabled": b,
      children: [
        typeof x == "string" && /* @__PURE__ */ y(
          B,
          d({
            target: F[x],
            parent: be,
            component: "span",
            transitionDuration: "var(--sc-transition-duration)"
          }, S("indicator")),
          me
        ),
        ye
      ]
    })
  );
});
M.classes = ie;
M.displayName = "@mantine/core/SegmentedControl";
const Ye = "SegmentedControl-module__root___X-Vyz", Ge = "SegmentedControl-module__control___fxOxs", Je = "SegmentedControl-module__label___3A8-4", Ve = "SegmentedControl-module__indicator___sfk4y", Ze = "SegmentedControl-module__labelWithIcons___xQ3iu", et = "SegmentedControl-module__leftIcon___tTTIv", tt = "SegmentedControl-module__labelText___ULScj", W = {
  root: Ye,
  control: Ge,
  label: Je,
  indicator: Ve,
  labelWithIcons: Ze,
  leftIcon: et,
  labelText: tt
}, nt = (t) => t.map((e) => {
  if (typeof e == "string")
    return e;
  const c = e, { leftIcon: n, label: o, accessibleLabel: r } = c, i = z(c, ["leftIcon", "label", "accessibleLabel"]);
  if (!n)
    return e;
  const m = /* @__PURE__ */ Z("div", { className: W.labelWithIcons, children: [
    /* @__PURE__ */ y(n, { size: 14, className: W.leftIcon }),
    o && /* @__PURE__ */ y("span", { className: W.labelText, children: o }),
    r && /* @__PURE__ */ y(Fe, { children: r })
  ] });
  return f(d({}, i), {
    label: m
  });
}), ot = Ne(
  (i, r) => {
    var l = i, { className: t, size: e = "md", data: n } = l, o = z(l, ["className", "size", "data"]);
    const m = nt(n);
    return /* @__PURE__ */ y(
      M,
      f(d({
        ref: r,
        classNames: f(d({}, W), {
          indicator: W.indicator
        }),
        transitionDuration: 200,
        transitionTimingFunction: "ease",
        data: m
      }, o), {
        mod: { size: e }
      })
    );
  }
);
ot.displayName = "SegmentedControl";
export {
  ot as SegmentedControl
};
